import { Home, Users, Box, HelpCircle, Star, DollarSign, Gift, Calendar, Award, Clipboard, Tablet, BarChart2, Activity, ShoppingBag } from "react-feather";

export const MENUITEMS = [
  {
    menutitle: "General",
    Items: [
      {
        title: "Home",
        icon: Home,
        active: false,
        path: '/dashboard',
      },
    ],
  },
  {
    menutitle: "Offers",
    Items: [
      {
        title: "Offers",
        icon: Box,
        active: false,
        path: '/offers',
      },
    ],
  },
  {
    menutitle: "Survey",
    Items: [
      {
        title: "Surveys",
        icon: HelpCircle,
        active: false,
        path: '/surveys',
      },
    ],
  },

  {
    menutitle: "Tournament",
    Items: [
      {
        title: "Tournament",
        icon: Star,
        active: false,
        path: '/tournament',
      },
    ],
  },

  {
    menutitle: "Referrals",
    Items: [
      {
        title: "Referrals",
        icon: Users,
        active: false,
        path: '/referrals',
      },
    ],
  },

  {
    menutitle: "Check-in",
    Items: [
      {
        title: "Check-in",
        icon: Calendar,
        active: false,
        path: '/check-in',
      },
    ],
  },

  {
    menutitle: "Tasks",
    Items: [
      {
        title: "Tasks",
        icon: Clipboard,
        active: false,
        path: '/tasks',
      },
    ],
  },

  {
    menutitle: "Games",
    Items: [
      {
        title: "Games",
        icon: Tablet,
        active: false,
        path: '/games',
      },
    ],
  },

  // {
  //   menutitle: "Lottery",
  //   Items: [
  //     {
  //       title: "Lottery",
  //       icon: Award,
  //       active: false,
  //       path: '/lottery',
  //     },
  //   ],
  // },

  // {
  //   menutitle: "Contests",
  //   Items: [
  //     {
  //       title: "Contests",
  //       icon: BarChart2,
  //       active: false,
  //       path: '/contests',
  //     },
  //   ],
  // },

  // {
  //   menutitle: "Jackpot",
  //   Items: [
  //     {
  //       title: "Jackpot",
  //       icon: Activity,
  //       active: false,
  //       path: '/jackpot',
  //     },
  //   ],
  // },

  // {
  //   menutitle: "Cashback",
  //   Items: [
  //     {
  //       title: "Cashback",
  //       icon: ShoppingBag,
  //       active: false,
  //       path: '/cashbacks',
  //     },
  //   ],
  // },

  {
    menutitle: "Rewards",
    Items: [
      {
        title: "Rewards",
        icon: Gift,
        active: false,
        path: '/rewards',
      },
    ],
  }
];
